module.exports = __webpack_public_path__ + "static/media/cd2-icon-calendar.1b5a52f7.svg";